import type { FC } from 'react';

import { Button, Typography } from '@mui/material';
import { CheckIcon } from '@truvhq/ui';

import { ResponsiveDialog } from 'shared/ui/ResponsiveDialog';

import type { UpgradePromoToastProps } from './UpgradePromoToast';

export type UpgradePromoModalProps = UpgradePromoToastProps & {
  onViewAllPlans: () => void;
};

export const UpgradePromoModal: FC<UpgradePromoModalProps> = ({
  pitch,
  onCta,
  onMaybeLater,
  onDismiss,
  onViewAllPlans,
}) => (
  <ResponsiveDialog
    open
    actions={
      <>
        <Button className="text-grey60" variant="text" onClick={onViewAllPlans}>
          View all plans
        </Button>
        <Button variant="outlined" onClick={onMaybeLater}>
          Maybe later
        </Button>
        <Button autoFocus color="primary" variant="contained" onClick={onCta}>
          {pitch.ctaLabel}
        </Button>
      </>
    }
    title={pitch.headline}
    onClose={onDismiss}
  >
    <ul className="flex flex-col gap-3">
      {pitch.bullets.map((bullet) => (
        <li key={bullet} className="flex items-start gap-2">
          <CheckIcon className="mt-1 h-4 w-4 flex-none text-primary-main" />
          <Typography className="text-grey100" variant="body1">
            {bullet}
          </Typography>
        </li>
      ))}
    </ul>
  </ResponsiveDialog>
);
